<div class="bg-white" [ngClass]="(srvRpDesign.isMobile$ | async) ? 'p-4' : 'px-0 px-sm-3 m-3'">
  <div class="item-center app-auth-header-icon" [ngClass]="(srvRpDesign.isMobile$ | async) ? 'm-3' : 'm-5'">
    <div>
      <mat-icon svgIcon="falBell" class="icon-center" [ngStyle]="UIUtilityService.getWarningIconStyle()"></mat-icon>
    </div>
  </div>

  <div class="d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
    <span
      class="font-dialog-confirm-title text-center"
      [ngClass]="{'mobile-font-dialog-confirm-title': (srvRpDesign.isMobile$ | async)}">
      {{ 'APP_AUTHENTICATOR.ENABLE_NOTIFICATION_TITLE' | translate }}
    </span>
  </div>

  <div class="font-dialog-confirm-content" mat-dialog-content [ngClass]="(srvRpDesign.isMobile$ | async) ? 'my-3 p-0 mobile-font-dialog-confirm-content' : 'mt-4 mx-3'">
    <p class="text-left">
      {{ (permissionDenied ? 'APP_AUTHENTICATOR.ENABLE_NOTIFICATION_DENIED_MESSAGE' : 'APP_AUTHENTICATOR.ENABLE_NOTIFICATION_MESSAGE') | translate }}
    </p>
  </div>

  <div class="enable-notification-actions d-flex justify-content-center" mat-dialog-actions
    [class.has-two-actions]="!permissionDenied" [ngClass]="(srvRpDesign.isMobile$ | async) ? 'gap-2' : 'my-3 gap-3'">
    <button class="font-button button-action-cancel p-4" mat-button cdkFocusInitial (click)="onDismiss()">
      {{ 'APP_AUTHENTICATOR.ENABLE_NOTIFICATION_DISMISS' | translate }}
    </button>
    @if (!permissionDenied) {
      <button class="font-button button-action-base p-4" mat-button (click)="onEnable()">
        {{ 'APP_AUTHENTICATOR.ENABLE_NOTIFICATION_ENABLE' | translate }}
      </button>
    }
  </div>
</div>
